// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1f7Ip","cell":"ColumnAccessor_cell__3Bge3","firstCellAccent":"ColumnAccessor_firstCellAccent__3jN6E"};